module.exports = __webpack_public_path__ + "static/media/sniper_vest.1955b2fb.png";